<template>
  <div class="container">
    <router-link to="/dashboard" class="alt-link">&lt; Back to Dashboard</router-link>

    <div class="component-container align-center" v-if="loading">
      <InlineSpinner />
    </div>

    <div class="component-container" v-if="application.role === auctionRoles.WINNER.value">
      <h1 class="align-center">Congratulations on Winning the Auction!</h1>

      <div v-if="!loading && application.id">

        <div class="status-indicators clearfix">
          <div class="status" :class="{ active: auction.status === auctionStatuses.PROCESSING.value }">
            <div><v-icon :color="auction.status === auctionStatuses.PROCESSING.value ? 'pfxBrand' : 'grey lighten-1'">lens</v-icon></div>
            Purchase Agreement
          </div>
          <div class="status" :class="{ active: auction.status === auctionStatuses.IN_ESCROW.value }">
            <div><v-icon :color="application.status === auctionStatuses.IN_ESCROW.value ? 'pfxBrand' : 'grey lighten-1'">lens</v-icon></div>
            In Escrow
          </div>
          <div class="status" :class="{ active: (auction.status === auctionStatuses.SOLD.value || auction.status === auctionStatuses.CLOSED.value) }">
            <div><v-icon :color="(application.status === auctionStatuses.SOLD.value || application.status === auctionStatuses.CLOSED.value) ? 'pfxBrand' : 'grey lighten-1'">lens</v-icon></div>
            Closed
          </div>
        </div>

        <div class="status-notification">
          <div class="color-bar">You are the WINNER of the auction!</div>
        </div>

        <div class="grey-box-container">

          <p style="font-size: 1.2rem">
            Congratulations on being the winning bidder on <strong>{{ auction.address }}</strong>
            with the winning bid of <strong>{{ auction.currentPrice | prettyMoney }}</strong>.
          </p>

          <template v-if="auction.status === auctionStatuses.PROCESSING.value">
            <p>
              The next step is to sign the Purchase Agreement! The Purchase Agreement is current being
              processed and will be available to you soon. The agent will contact you about this.
            </p>
            <p>
              You have <strong>24 hours</strong> to complete the signing process.
            </p>
            <p>
              Please don't hesitate to get in contact.
            </p>
          </template>

          <template v-if="auction.status === auctionStatuses.IN_ESCROW.value">
            <p>
              The escrow company is currently executing the closing process.
            </p>
            <p>
              Please don't hesitate to get in contact.
            </p>
          </template>

          <template v-if="auction.status === auctionStatuses.SOLD.value || auction.status === auctionStatuses.CLOSED.value">
            <p>
              The property auction is now closed.
            </p>
          </template>

          <div class="clearfix">
            <img :src="listingAgentProfile.photoUrl" class="user-avatar" style="float: left; width: 5rem; margin: .5rem 1rem 0 0;"/>
            <div style="margin-left: 6rem;">
              <strong>{{ listingAgentProfile.firstName }} {{ listingAgentProfile.lastName }}</strong><br/>
              {{ listingAgentProfile.title }}, {{ application.injected.tenant.name }}<br/>
              <a :href="'mailto:' + listingAgentProfile.email">{{ listingAgentProfile.email }}</a><br/>
              {{ listingAgentProfile.phone }}<br/>
              {{ listingAgentProfile.officePhone }}<br/>
            </div>
          </div>
        </div>

        <div class="grey-box-container">
          <div class="clearfix">
            <div class="col13" style="position:relative;">
              <img :src="auctionPhoto(auction)" />
              <img :src="tenantLogoUrl(application.injected.tenant)" style="position:absolute; top:.5rem; left:.5rem; width:25%;"/>
            </div>
            <div class="col23">
              <h2>{{ auction.address }}</h2>
              <div>{{ auction.zip }} {{ auction.city }}, {{ auction.state }}</div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
  import { auctionRoles, auctionStatuses, tenantLogoUrl } from '../utils/PfxUtils.js'
  import InlineSpinner from './elements/InlineSpinner.vue'

  export default {
    name: 'AuctionWinnerPage',
    components: {
      InlineSpinner
    },
    data() {
      return {
        auctionRoles,
        auctionStatuses,
        loading: false,
        auctionId: parseInt(this.$route.params.auctionId),
        auction: {},
        applicationId: parseInt(this.$route.params.applicationId),
        application: {},
        listingAgentProfile: {}
      }
    },
    created() {
      this.loadData()
    },
    methods: {
      tenantLogoUrl,

      loadData() {
        const that = this
        that.loading = true

        that.$PfxBackendApi.getAuction(that.auctionId).then(res => {
          console.log('getAuction res', res)
          that.auction = res.data || {}
          const subdomain = that.auction.tenant.subdomain

          that.$PfxBackendApi.getAuctionApplication(subdomain, that.auction.id, that.applicationId).then(res => {
            console.log('getAuctionApplication res', res)
            const application = res.data || {}

            if (application.id) {
              that.loading = 2
              application.injected = {}
              that.application = application

              // Fetch public tenant information (for tenant logo)
              that.$PfxBackendApi.getTenantPublic(subdomain).then(res => {
                console.info('getTenantPublic res', res)
                application.injected.tenant = res.data || {}
              }).catch(err => {
                console.error('getTenantPublic error', err)
              }).then(() => that.loading--)

              // fetch listing agent profile
              const listingAgentSub = that.auction.listingAgent
              that.$PfxBackendApi.getUser(listingAgentSub).then(res => {
                console.info('getUser (listing agent) res', res)
                that.listingAgentProfile = res.data || {}
              }).catch(err => {
                console.error('getUser (listing agent) res', err)
                this.$notify({ type: 'danger', message: 'Cannot fetch listing agent profile' })
              }).then(() => that.loading--)

            } else { // no application found
              that.loading = false
            }

          }).catch(err => {
            console.error('getAuctionApplication err', err)
            this.$notify({ type: 'danger', message: 'Cannot fetch data about auction winning with id ' + that.applicationId })
            that.loading = false
          })

        }).catch(err => {
          console.error('getAuction err', err)
          this.$notify({ type: 'danger', message: 'Cannot fetch data about auction with id ' + that.auctionId })
          that.loading = false
        })
      },

      auctionPhoto(auction) {
        if (auction && auction.metadata && auction.metadata.photos && Array.isArray(auction.metadata.photos) && auction.metadata.photos.length > 0) {
          return auction.metadata.photos[0]
        } else {
          return require('../assets/placeholder-photos.jpg')
        }
      }

    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  .col13 { @include column(1/3); }
  .col23 { @include column(2/3); }
  .status { @include column(1/3, $gutter: 0); }
  img { width: 100%; }

  .component-container {
    @include center($max-width: 720px);
  }

  .status-indicators {
    padding: 1rem 0 2rem;
    text-align: center;
    color: #aaa;
    .active {
      color: #555;
      font-weight: 600;
    }
    .status {
      div {
        color: #aaa;
        background-image: linear-gradient(180deg,
          rgba(0,0,0,0) calc(50% - 1px), // TODO buggy on some browsers
          rgba(192,192,192,0.5) calc(50%),
          rgba(0,0,0,0) calc(50% + 1px));
      }
      &:first-child {
        div {
          background-size: 50% 100%;
          background-position: 100%;
        }
      }
      &:last-child {
        div {
          background-size: 50% 100%;
        }
      }
    }
  }

  .status-notification {
    .color-bar {
      text-align: center;
      background-color: $color-gold;
      background-image: $gradient-gold;
      color: #000;
      padding: 0.25em;
      font-size: 1.2rem;
    }
    margin-bottom: 1rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/AuctionWinnerPage.vue